<template>
    <v-form ref="form" data-cy="TO-conditions" class="pt-4">
        <div class="pb-4">
            <LocaleSwitcher @change="changeActiveLangCode" />
        </div>
        <template v-if="isShowEditors && !isLoading">
            <v-col
                v-for="{conditionsByLang, productType} in conditions"
                :key="productType ? productType : 'common'"
                cols="12"
                lg="10"
                class="px-0 pt-0"
            >
                <template v-if="!htmlEditorRefs?.length && conditions?.length">
                    <v-skeleton-loader type="list-item-two-line" />
                </template>
                <NewHtmlEditor
                    ref="htmlEditorRefs"
                    v-model="conditionsByLang[activeLangCode]"
                    :label="productType ? $t(`productType.${productType}`) : $t('common')"
                >
                    <div
                        v-if="activeLangCode"
                        class="fi fill-height px-3"
                        :class="[`fi-${useFlagIconCode(activeLangCode)}`]"
                    />
                </NewHtmlEditor>
            </v-col>
        </template>
        <v-btn :disabled="isLoading" data-cy="save" @click="save">
            {{ $t('save') }}
        </v-btn>
    </v-form>
</template>
<script setup lang="ts">
    import {useFlagIconCode} from '~/composables/helpers'
    const NewHtmlEditor = defineAsyncComponent(() => import('~/components/admin/NewHtmlEditor.vue'))

    const isLoading = ref<boolean>(false)
    const conditions = ref([])
    const activeLangCode = ref<string>('en')
    const isShowEditors = ref<boolean>(false)
    const htmlEditorRefs = ref([])

    const {$api, $toast, $i18n} = useNuxtApp()
    const {t} = useI18n()

    onMounted(async () => {
        activeLangCode.value = $i18n.locale.value
        await loadData()
    })

    async function loadData(): Promise<void> {
        isLoading.value = true
        try {
            const {conditions: conditionsList} = await $api.turOpConditions.get()

            const commonElIndex = conditionsList.findIndex(({productType}) => !productType)
            if (commonElIndex !== 0 && commonElIndex === conditionsList.length - 1) {
                conditions.value = conditionsList.reverse()
            } else {
                conditions.value = conditionsList
            }

            isShowEditors.value = true
        } catch (e) {
            $toast.error(t('error_message.load_error'))
        } finally {
            isLoading.value = false
        }
    }

    const save = async () => {
        try {
            await $api.turOpConditions.put({conditions: conditions.value})
            $toast.success(t('success_message.saved_successfully'))
        } catch (e) {
            $toast.error(e.msg || e.errors[0].message)
        }
    }

    const flickEditors = (): void => {
        isShowEditors.value = false
        nextTick().then(() => {
            isShowEditors.value = true
        })
    }

    const changeActiveLangCode = (code: string): void => {
        activeLangCode.value = code
        flickEditors()
    }
</script>
